/* eslint-disable no-param-reassign */
import { call, put, select } from "redux-saga/effects";
import Sonda from "@gcloud-npm/bit.utils.front-sonda";
import { getProductByAlias } from "@gcloud-npm/bit.adabyron-cloud.orion";
import { actions as productActions } from "../reducers/product";
import { ALIAS } from "../constants/aliasProduct";
import { normalizeBenefits } from "./normalizers/benefits";
import { normalizeHome } from "./normalizers/home";
import { normalizeExpert } from "./normalizers/expert";
import { normalizeDigital } from "./normalizers/digital";
import { normalizeConsulting } from "./normalizers/consulting";
import { normalizeAyuda } from "./normalizers/ayuda";
import { normalizeContratos } from "./normalizers/contratos";

const contextStore = (state) => state.context.data;

/**
 * Obtiene todas las Home
 * @returns {undefined}
 */
export function* getProductInfo({ payload }) {
  const context = yield select(contextStore);
  const { alias } = payload;
  const sonda = new Sonda({
    processName: "getProductInfo",
    context,
    filePath: "sagas/product",
  });

  try {
    const dataToAdabyron = {
      alias,
    };
    const argsToAdabyron = [dataToAdabyron, context];
    let response = "";
    try {
      response = yield call(getProductByAlias, ...argsToAdabyron);
    } catch (error) {
      sonda.severalMessage({
        error,
        info: `Fallo del servicio en alias: ${alias}`,
      });
      switch (alias) {
        case ALIAS.AYUDA:
          yield put(
            productActions.getAyudaInfoFailure(
              `Fallo del servicio en alias: ${alias}`
            )
          );
          break;
        case ALIAS.DIGITAL:
          yield put(
            productActions.getDigitalInfoFailure(
              `Fallo del servicio en alias: ${alias}`
            )
          );
          break;
        case ALIAS.CONSULTING:
          yield put(productActions.getConsultingInfoFailure(`Fallo del servicio en alias: ${alias}`));
          break;
        case ALIAS.EXPERTO:
          yield put(
            productActions.getExpertoInfoFailure(
              `Fallo del servicio en alias: ${alias}`
            )
          );
          break;
        case ALIAS.BENEFICIOS:
          yield put(
            productActions.getBeneficiosInfoFailure(
              `Fallo del servicio en alias: ${alias}`
            )
          );
          break;
        case ALIAS.CONTRATOS:
          yield put(
            productActions.getContratosInfoFailure(
              `Fallo del servicio en alias: ${alias}`
            )
          );
          break;
        case ALIAS.HOME:
        default:
          yield put(
            productActions.getHomeInfoFailure(
              `Fallo del servicio en alias: ${alias}`
            )
          );
          break;
      }
      return null;
    }
    let responseNormalized = null;

    switch (alias) {
      case ALIAS.AYUDA:
        responseNormalized = normalizeAyuda(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(productActions.getAyudaInfoSuccess(responseNormalized));
        } else {
          throw Error(
            "Estructura incorrecta tras normalizar la respuesta en entender ayudas"
          );
        }
        yield put(productActions.getAyudaInfoSuccess(response));
        break;
      case ALIAS.DIGITAL:
        responseNormalized = normalizeDigital(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(productActions.getDigitalInfoSuccess(responseNormalized));
        } else {
          throw Error(
            "Estructura incorrecta tras normalizar la respuesta en kit digital"
          );
        }
        yield put(productActions.getDigitalInfoSuccess(response));
        break;
      case ALIAS.CONSULTING:
        responseNormalized = normalizeConsulting(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(productActions.getConsultingInfoSuccess(responseNormalized));
        } else {
          throw Error('Estructura incorrecta tras normalizar la respuesta en kit consulting')
        }
        yield put(productActions.getConsultingInfoSuccess(response));
        break;
      case ALIAS.EXPERTO:
        responseNormalized = normalizeExpert(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(productActions.getExpertoInfoSuccess(responseNormalized));
        } else {
          throw Error(
            "Estructura incorrecta tras normalizar la respuesta en experto digital"
          );
        }
        yield put(productActions.getExpertoInfoSuccess(response));
        break;
      case ALIAS.BENEFICIOS:
        responseNormalized = normalizeBenefits(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(
            productActions.getBeneficiosInfoSuccess(responseNormalized)
          );
        } else {
          throw Error(
            "Estructura incorrecta tras normalizar la respuesta en beneficios"
          );
        }
        yield put(productActions.getBeneficiosInfoSuccess(response));
        break;
      case ALIAS.CONTRATOS:
        responseNormalized = normalizeContratos(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(productActions.getContratosInfoSuccess(responseNormalized));
        } else {
          throw Error(
            "Estructura incorrecta tras normalizar la respuesta en contratos"
          );
        }
        yield put(productActions.getContratosInfoSuccess(response));
        break;
      case ALIAS.HOME:
      default:
        responseNormalized = normalizeHome(response);
        if (responseNormalized && Array.isArray(responseNormalized)) {
          yield put(productActions.getHomeInfoSuccess(responseNormalized));
        } else {
          throw Error(
            "Estructura incorrecta tras normalizar la respuesta en fondos europeos"
          );
        }
        yield put(productActions.getHomeInfoSuccess(response));
        break;
    }
  } catch (error) {
    sonda.severalMessage({ error });

    switch (alias) {
      case ALIAS.AYUDA:
        yield put(productActions.getAyudaInfoFailure(error.message));
        break;
      case ALIAS.DIGITAL:
        yield put(productActions.getDigitalInfoFailure(error.message));
        break;
      case ALIAS.CONSULTING:
        yield put(productActions.getConsultingInfoFailure(error.message));
        break;
      case ALIAS.EXPERTO:
        yield put(productActions.getExpertoInfoFailure(error.message));
        break;
      case ALIAS.BENEFICIOS:
        yield put(productActions.getBeneficiosInfoFailure(error.message));
        break;
      case ALIAS.CONTRATOS:
        yield put(productActions.getContratosInfoFailure(error.message));
        break;
      case ALIAS.HOME:
      default:
        yield put(productActions.getHomeInfoFailure(error.message));
        break;
    }
    return null;
  }
}
